module.exports = __webpack_public_path__ + "img/onepack-active.8f5d3425.svg";